import React from 'react';
import classNames from 'classnames';

import {labels} from '../../../../../../../util/utils';

import {CUSTOM_COLUMNS} from '../utils/constants';

import OutputText from '@ey/canvascoreservices/OutputText';

import RadioButtonGroup from '../../../../../../CoreWrappers/RadioButtonGroup';
import ListWithScroll from '../../../../../../Common/ListWithScroll';
import StyledAttributesList from './StyledAttributesList';
import StyledAttributesGroup from './StyledAttributesGroup';

const AttributesPanel = ({values, errors, handleChange, handleSubmit, handleReset, isLoading}) => {
	const id = CUSTOM_COLUMNS;
	const listOfCC = values[id];

	const onChange = (groupId, value) => {
		const newValue = listOfCC?.map((group) => {
			if (group?.id === groupId) {
				if (group?.value?.id === value) return {...group, value: null};
				if (group?.columnValues?.some((val) => val.id === value))
					return {...group, value: group?.columnValues?.find((val) => val.id === value)};
				return {...group, value};
			}
			return {...group};
		});
		handleChange(CUSTOM_COLUMNS, newValue);
	};

	const renderColumn = ({name, id, columnValues, value = null}) => {
		const props = {
			id,
			name: id,
			options: columnValues.map(({id, name: label}) => ({id, label})),
			value: value?.id ?? null,
			onChange: (value) => onChange(id, value)
		};

		return (
			<StyledAttributesGroup>
				{name && (
					<OutputText ellipsis title={name}>
						{name}
					</OutputText>
				)}
				<RadioButtonGroup {...props} />
			</StyledAttributesGroup>
		);
	};

	const props = {
		list: listOfCC,
		item: renderColumn,
		emptyTitle: labels.noCustomColumns,
		includeWrapper: false,
		Wrapper: StyledAttributesList
	};

	return <ListWithScroll {...props} />;
};

AttributesPanel.propTypes = {};

export default AttributesPanel;
